import { useQueryState } from "@msuite/ui/libs/nuqs";
import { LoadingScreen } from "@msuite/ui/loading-screen";
import { Panels } from "@msuite/ui/panels";
import { useRoles } from "@/hooks/use-roles";
import { RoleDetailPanel } from "../role-detail";
import { RoleList } from "./role-list";

/**
 * The roles surface as one screen: the roles on the left, the selected role's members and
 * permission grid on the right, both under the settings tabs so the reader never leaves them.
 *
 * The selection is a URL parameter, so a role stays open across a reload and can be linked to;
 * a selection that no longer resolves — the role was deleted — falls back to the first role
 * rather than an empty panel.
 */
export function OrganizationSettingsRoles() {
	/** Query */
	const { roles, isLoading } = useRoles();

	/** State */
	const [selectedRoleId, setSelectedRoleId] = useQueryState("role");

	/** Computed */
	const activeRole = roles.find((role) => role.id === selectedRoleId) ?? roles.at(0);

	/** Guard */
	if (isLoading && !roles.length) return <LoadingScreen />;

	/** Render */
	return (
		<Panels resizable>
			<Panels.Panel flex={1}>
				<RoleList
					roles={roles}
					selectedRoleId={activeRole?.id ?? null}
					onSelect={setSelectedRoleId}
				/>
			</Panels.Panel>
			<Panels.Panel flex={3}>
				{activeRole && <RoleDetailPanel roleId={activeRole.id} />}
			</Panels.Panel>
		</Panels>
	);
}
